import { Action, OperationType } from '../../../../dispatcher/Types';

/**
 * Returns to the Dispatcher:
 *  - filters object
 *  - filters url
 */
export const GetFilterParams: Action = [{
  data: {
    template: {
      bind: {
        filterType: '{filterType} || "filters"'
      }
    }
  },
  type: OperationType.data
}, {
  condition: '{filterType} === "filters"',
  conditionOperations: [{
    moduleName: 'FilterDialog',
    name: 'getFilterParams',
    mappingName: 'filterParams',
    type: OperationType.addOperationData
  }],
  elseOperations: [{
    moduleName: 'FilterDialog',
    name: 'getSearchFilterParams',
    mappingName: 'filterParams',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  name: 'getEndPoint',
  args: ['filterType'],
  moduleName: 'SearchBar',
  mappingName: 'filterUrl',
  type: OperationType.addOperationData
}, {
  data: {
    filterUrlParamsName: 'urlParams'
  },
  name: 'getEndPoint',
  args: ['filterUrlParamsName'],
  moduleName: 'SearchBar',
  mappingName: 'filterUrlParams',
  type: OperationType.addOperationData
}];

/**
 * Posts filters requests with filters as params
 */
export const FilterRequest: Action = [{
  data: {
    filterType: 'search'
  },
  type: OperationType.data
}, {
  name: 'GetFilterParams',
  type: OperationType.action
}, {
  data: {
    template: {
      filterType: 'advancedFilter',
      bind: {
        params: '{filterParams}'
      }
    }
  },
  name: 'triggerSearch',
  type: OperationType.action
}];

/**
 * Posts filters requests with filters as params
 */
export const SearchFilter: Action = [{
  name: 'FilterRequest',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        params: '{filterParams}'
      }
    }
  },
  name: 'triggerSearch',
  type: OperationType.action
}, {
  name: 'closeDialog',
  type: OperationType.action
}];

/**
 * Saves filters
 */
export const SaveFilter: Action = [{
  name: 'GetFilterParams',
  type: OperationType.action
}, {
  moduleName: 'SearchBar',
  name: 'getDashboard',
  mappingName: 'dashboard',
  type: OperationType.addOperationData
}, {
  moduleName: 'FilterDialog',
  name: 'isFilterNameExisted',
  mappingName: 'updatedFilter',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        url: '{filterUrl}',
        method: '{updatedFilter}?"put":"post"',
        urlParams: '{filterUrlParams}'
      },
      params: {
        bind: {
          filterName: '{filterParams}.filterName',
          dashboard: '{dashboard}',
          filterParams: '{filterParams}.filterParams',
          userName: '{filterUrlParams}.usernameFilters'
        }
      }
    }
  },
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        url: '{filterUrl}',
        urlParams: '{filterUrlParams}'
      }
    }
  },
  name: 'GetSavedFilters',
  type: OperationType.action
}, {
  args: ['savedFilters'],
  name: 'updateSavedFilters',
  moduleName: 'FilterDialog'
}];

/**
 * Gets all saved filters
 */
export const GetSavedFilters: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '{url}',
        urlParams: '{urlParams}'
      },
      params: {
        bind: {
          dashboard: '{dashboard}'
        }
      }
    }
  },
  mappingName: 'savedFilters',
  type: OperationType.request
}];

export const UpdateFilters: Action = [{
  buttons: [{
    disabled: '{isSaveFilterDisabled}',
    name: 'FilterDialog.saveFilter'
  }],
  dialogName: 'FilterDialog',
  type: OperationType.updateDialog
}];
